<template>
  <div class="modal-content fm-modal-audio-player">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ lang.modal.audioPlayer.title }}
      </h5>
      <button type="button" class="btn-close" aria-label="Close" v-on:click="hideModal"></button>
    </div>
    <div class="modal-body">
      <audio ref="fmAudio" controls />
      <hr />
      <div
          class="d-flex justify-content-between py-2 px-2"
          v-bind:class="playingIndex === index ? 'bg-light' : ''"
          v-for="(item, index) in audioFiles"
          v-bind:key="index"
      >
        <div class="w-75 text-truncate">
          <span class="text-muted pr-2">{{ index }}.</span>
          {{ item.basename }}
        </div>
        <template v-if="playingIndex === index">
          <div v-if="status === 'playing'">
            <i v-on:click="togglePlay()" class="bi bi-play-fill active" />
          </div>
          <div v-else>
            <i v-on:click="togglePlay()" class="bi bi-pause-fill" />
          </div>
        </template>
        <template v-else>
          <div>
            <i v-on:click="selectTrack(index)" class="bi bi-play-fill" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Plyr from 'plyr';
import modal from '@/Modules/FileManager/views/components/modals/mixins/modal';
import translate from '@/Modules/FileManager/mixins/translate';

export default {
  name: 'AudioPlayerModal',
  mixins: [modal, translate],
  data() {
    return {
      player: {},
      playingIndex: 0,
      status: 'paused',
    };
  },
  mounted() {
    // initialize Plyr
    this.player = new Plyr(this.$refs.fmAudio, {
      speed: {
        selected: 1,
        options: [0.5, 1, 1.5],
      },
    });

    // select first item in the list
    this.setSource(this.playingIndex);

    // add event listeners
    this.player.on('play', () => {
      this.status = 'playing';
    });

    this.player.on('pause', () => {
      this.status = 'paused';
    });

    this.player.on('ended', () => {
      if (this.audioFiles.length > this.playingIndex + 1) {
        // play next track
        this.selectTrack(this.playingIndex + 1);
      }
    });
  },
  beforeDestroy() {
    // destroy player
    this.player.destroy();
  },
  computed: {
    selectedDisk() {
      return this.$store.getters['fm/selectedDisk'];
    },
    audioFiles() {
      return this.$store.getters['fm/selectedItems'];
    },
    authToken() {
      return Ls.get('auth.token');
    },
  },
  methods: {
    selectTrack(index) {
      if (this.player.playing) {
        this.player.stop();
      }
      this.setSource(index);
      this.player.play();
      this.playingIndex = index;
    },

    async setSource(index) {
      const audioUrl = `${this.$store.getters['fm/settings/baseUrl']}stream-file?disk=${this.selectedDisk}&path=${encodeURIComponent(this.audioFiles[index].path)}`;
      const token = this.authToken;

      try {
        const audioBlobUrl = await this.loadAudioWithAuth(audioUrl, token);
        this.player.source = {
          type: 'audio',
          title: this.audioFiles[index].filename,
          sources: [
            {
              src: audioBlobUrl,
              type: `audio/${this.audioFiles[index].extension}`,
            },
          ],
        };
      } catch (error) {
        console.error("Erreur lors du chargement de l'audio", error);
      }
    },

    async loadAudioWithAuth(url, token) {
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Erreur lors du téléchargement de l’audio');

        const blob = await response.blob();
        return URL.createObjectURL(blob); // Retourne l'URL du fichier Blob
      } catch (error) {
        throw new Error('Erreur réseau ou autre: ' + error.message);
      }
    },

    togglePlay() {
      this.player.togglePlay();
    },
  },
};
</script>

<style lang="scss">
//@import 'plyr/src/sass/plyr.scss';

.fm-modal-audio-player {
  .bi.bi-play-fill {
    color: gray;
    opacity: 0.1;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }

    &.active {
      opacity: 1;
      color: deepskyblue;
    }
  }

  .bi.bi-pause-fill {
    color: gray;
    opacity: 0.5;
    cursor: pointer;
  }
}
</style>
